import { Component, Vue, Inject, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "../../shared/constants/StyleConstants";
import {
  BUTTON_ACTION,
  INFO_CHART_NAMES,
  INFO_GROUPS_ACCESS,
  INFO_GROUP_CONSTANTS,
  INFO_GROUP_MAIN_FILTER,
  INFO_GROUP_SECONDARY_FILTERS,
  SAVE_INFO_GROUP_ID
} from "./constants/InfoGroupConstants";
import { Http } from "@status/codes";
import { InfoGroupQuerySend } from "./models/InfoGroupQuerySend";
import { InfoGroupService } from "./services/InfoGroupService";
import { Response } from "@/shared/models/Response";
import { InfoGroupDataResponse } from "./models/InfoGroupDataResponse";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "../../shared/constants/FormConstants";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { InfoGroupDetail } from "@/modules/InfoGroup/models/InfoGroupDetail";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import SaveInfoGroup from "./components/SaveInfoGroup/SaveInfoGroup.vue";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import { Utils } from "@/shared/utils/utils";
import {
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { HeaderInfoGroup } from "./models/HeaderInfoGroup";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import store from "@/store";
import { NavigationGuardNext, Route } from "vue-router";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import { SearchContext } from "@/shared/models/SearchContext";
import { mapGetters } from "vuex";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { InfoGroupModel } from "./models/InfoGroup";
import SaveList from "../List/components/SaveList/SaveList.vue";
import Vuetify from "vuetify";
import { AxiosError } from "axios";

Vue.use(Vuetify);

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "InfoGroup",
  components: {
    ObservationModal,
    FormModalViewer,
    EmptyState,
    ModalTemplate,
    SaveInfoGroup,
    CrudChart,
    SaveList
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class InfoGroup extends Vue {
  @Inject() infoGroupService!: InfoGroupService;
  @Inject() userTemplateService!: UserTemplateService;

  dataToMainView!: MenuDataStructure;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  ADD_INFO_GROUP_TEXT = INFO_GROUP_CONSTANTS.BUTTON.ADD_INFO_GROUP_TEXT;
  TITLE_PAGE = INFO_GROUP_CONSTANTS.PAGE_TITLE;
  TOGGLE = BUTTON_ACTION.TOGGLE_INFO_GROUP;
  OPERATIONS = [LIST_DATA_EVENTS.VIEW_DATA];
  EMPTY_STATE_HEADER = INFO_GROUP_CONSTANTS.EMPTY_STATE.EMPTY_STATE_HEADER;
  EMPTY_STATE_PARAGRAPH =
    INFO_GROUP_CONSTANTS.EMPTY_STATE.EMPTY_STATE_PARAGRAPH;

  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  currentTooltip = INFO_GROUP_CONSTANTS.BUTTON.ADD_INFO_GROUP_TEXT;
  dialogPreview = false;
  clearModel = false;
  infoGroupData: InfoGroupDetail = new InfoGroupDetail();
  isEditing = false;
  updateEditing = 0;
  selectedInfoGroupId = "";
  selectedInfoGroup: InfoGroupModel = {} as InfoGroupModel;
  cancelModalSaveList = false;

  filterQuery: InfoGroupQuerySend = { chart: "true" };
  infoGroupList: HeaderInfoGroup[] = [];
  infoGroupListTemp: HeaderInfoGroup[] = [];

  filterItems: Filter = INFO_GROUP_MAIN_FILTER;
  initialList: {
    key: string;
    name: string;
  }[] = [];

  infoGroupChartData = CHART_INIT;

  isLoadingCharts = false;
  showCharts = false;
  canSearch = true;
  loadingInfoGroup = false;
  showInfoGroupComponent = false;
  auxGroupId = "";
  admin = false;
  showModalCreateList = false;

  mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.INFO_GROUP
    );

    this.emitSearchInitializer();
    this.getChartData();
  }

  initializeFilters() {
    this.filterItems.secondaryFilters = [];
    this.filterItems.secondaryFilters.push(INFO_GROUP_SECONDARY_FILTERS.NAME);
    this.filterItems.secondaryFilters.push(INFO_GROUP_SECONDARY_FILTERS.STATUS);
  }

  async getChartData() {
    this.isLoadingCharts = true;
    this.showCharts = false;

    const response = await this.getDataByFilter();

    if (response.code === Http.Found && response.data != undefined) {
      if (response.data.chartData) {
        this.infoGroupChartData = {
          chartTitle: INFO_GROUP_CONSTANTS.INFO_GROUP_STATE_TITLE,
          chartRenderData: Utils.mapChartData(
            response.data.chartData,
            INFO_CHART_NAMES.STATES
          )
        };
      }
      this.infoGroupList = response.data.groups;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        this.infoGroupList
      );
      this.showCharts = true;
    } else {
      this.infoGroupChartData = CHART_INIT;
      this.showCharts = false;
    }
    this.isLoadingCharts = false;
  }

  async searchData() {
    this.isLoadingCharts = true;
    this.showCharts = false;
    this.canSearch = false;
    this.infoGroupList = [];

    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );

    const response = await this.getDataByFilter();

    if (response.code === Http.Found && response.data !== undefined) {
      this.infoGroupList = response.data.groups;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        this.infoGroupList
      );
      if (response.data.chartData) {
        this.infoGroupChartData = {
          chartTitle: INFO_GROUP_CONSTANTS.INFO_GROUP_STATE_TITLE,
          chartRenderData: Utils.mapChartData(
            response.data.chartData,
            INFO_CHART_NAMES.STATES
          )
        };
      }
      this.showCharts = true;
      this.canSearch = true;
    } else {
      if (response.code === Http.NotFound) {
        Snackbar.popInfo(response.message);
      } else {
        Snackbar.popError(response.message);
      }
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      this.showCharts = false;
    }
    this.isLoadingCharts = false;
  }

  async showInfoGroupDetails(infoGroupId: string) {
    try {
      const response = await this.infoGroupService.getInfoGroupSchemaById(
        infoGroupId
      );

      if (response.code === Http.Found && response.data != null) {
        this.infoGroupData = response.data;
        this.dialogPreview = true;
        this.clearModel = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getDataByFilter(): Promise<Response<InfoGroupDataResponse>> {
    try {
      this.filterQuery.chart = "true";
      const data = await this.infoGroupService.getInfoGroupByFilters(
        this.filterQuery
      );

      return data;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        const RESPONSE_ACCESS_ERROR: Response<InfoGroupDataResponse> = {
          code: Http.Forbidden,
          message: FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        };
        return RESPONSE_ACCESS_ERROR;
      } else {
        const RESPONSE_ERROR: Response<InfoGroupDataResponse> = {
          code: Http.BadRequest,
          message: FORM_MESSAGES.REQUEST_FAILED,
          data: {
            groups: [],
            chartData: {}
          }
        };
        return RESPONSE_ERROR;
      }
    }
  }

  async getInfoGroupById(id: string) {
    try {
      const responseData = await this.infoGroupService.getInfoGroupById(id);

      if (responseData.code === Http.NotFound) {
        Snackbar.popError(
          INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR_EDIT_ID_NOT_FOUND
        );
      } else if (
        responseData.code === Http.Found &&
        responseData.data !== undefined
      ) {
        this.selectedInfoGroup = responseData.data;
        this.selectedInfoGroup.name =
          this.selectedInfoGroup.visualName ?? this.selectedInfoGroup.name;
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.GET}`
          : INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR;

      Snackbar.popError(errorMessage);
    }
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        await this.loadInfoGroup(action, itemId);
        break;
      case LIST_DATA_EVENTS.VIEW_DATA:
        await this.showInfoGroupDetails(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteInfoGroup(itemId);
        this.cancelInfoGroupConfiguration();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateInfoGroup(itemId, STATE.ACTIVE);
        this.cancelInfoGroupConfiguration();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateInfoGroup(itemId, STATE.INACTIVE);
        this.cancelInfoGroupConfiguration();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.cancelInfoGroupConfiguration();
        break;
    }
  }

  async updateStateInfoGroup(documentId: string, state: string) {
    try {
      const responseData = await this.infoGroupService.updateStateInfoGroupById(
        documentId,
        state
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.searchData();
      } else if (responseData.code === Http.NotFound) {
        Snackbar.popError(
          INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR_EDIT_ID_NOT_FOUND
        );
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.PUT}`
          : INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR;

      Snackbar.popError(errorMessage);
    }
  }

  async addInfoGroup(newInfogroup: InfoGroupModel) {
    try {
      const responseData = await this.infoGroupService.addInfoGroup(
        newInfogroup
      );
      if (responseData.code == Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.searchData();
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
          ""
        );
      } else {
        Snackbar.popError(
          INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_INFO_GROUP
        );
      }
      this.cleanInfoGroup();
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async updateInfoGroup(data: {
    id: string;
    editingInfoGroup: InfoGroupModel;
  }) {
    try {
      const responseData = await this.infoGroupService.updateInfoGroup(
        data.id,
        data.editingInfoGroup
      );
      if (responseData.code == Http.Ok) {
        Snackbar.popSuccess(responseData.message);

        await this.searchData();
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
          ""
        );
      } else {
        Snackbar.popError(
          INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_INFO_GROUP
        );
      }
      this.cleanInfoGroup();
    } catch (error) {
      this.cleanInfoGroup();
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async deleteInfoGroup(id: string) {
    try {
      const responseData = await this.infoGroupService.deleteInfoGroup(id);

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(
          INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.INFO_GROUP_DELETED
        );
        this.searchData();
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(
          INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.INFO_GROUP_USED
        );
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  showInfoGroup(action: string, editId?: string) {
    if (action === this.TOGGLE) {
      if (this.currentIcon === GENERAL_CONSTANTS.ICONS.ADD) {
        this.selectedInfoGroupId = "";
        this.TITLE_PAGE = INFO_GROUP_CONSTANTS.ADD_PAGE_TITLE;
        this.show(true);
        Utils.scrollToElement(SAVE_INFO_GROUP_ID, this);
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
          { showOptions: this.showInfoGroupComponent }
        );
      } else {
        this.cancelInfoGroup();
      }
    } else if (action === LIST_DATA_EVENTS.EDIT_DATA && editId != undefined) {
      this.selectedInfoGroupId = editId;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        editId
      );
      this.show(true);
      this.TITLE_PAGE = INFO_GROUP_CONSTANTS.PAGE_EDIT_TITLE;
    } else {
      this.show(false);
    }
  }

  cancelInfoGroupConfiguration() {
    this.updateEditing = 1 - this.updateEditing;
    this.isEditing = false;
    this.showInfoGroupComponent = false;
    this.TITLE_PAGE = INFO_GROUP_CONSTANTS.PAGE_TITLE;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.currentTooltip = INFO_GROUP_CONSTANTS.ADD_PAGE_TITLE;
    this.selectedInfoGroupId = "";
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      ""
    );
  }

  closeModalPreview() {
    this.dialogPreview = false;
    this.clearModel = false;
    this.infoGroupData.phoneComponentList = [];
  }

  sendDataToLateralMenu(action: string, data?: unknown) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  async emitSearchInitializer() {
    this.initializeFilters();

    const searchContext: SearchContext = {
      title: INFO_GROUP_CONSTANTS.PAGE_GROUP_TITLE_SEARCH,
      filterArray: [this.filterItems],
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.INFO_GROUP,
      descriptions: ["description", "state"],
      textButtonCreate: INFO_GROUP_CONSTANTS.BUTTON.ADD_INFO_GROUP_TEXT
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.filterQuery = this.getFilter();
          this.searchData();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAdd();
          break;
      }
    }
  }

  show(showComponent: boolean, itemId?: string) {
    this.showInfoGroupComponent = showComponent;
    if (showComponent) {
      if (itemId) {
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
          itemId
        );
      }
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.currentTooltip = FORM_CONSTANTS.BUTTON.CANCEL;
    } else {
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        ""
      );
      this.filterQuery = { chart: "true" };
      this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
      this.currentTooltip = INFO_GROUP_CONSTANTS.ADD_PAGE_TITLE;
      this.selectedInfoGroupId = "";
    }
  }

  getFilter() {
    const query: InfoGroupQuerySend = { chart: "true" };
    if (INFO_GROUP_SECONDARY_FILTERS.NAME.key in this.dataToMainView.data) {
      const nameValue = this.dataToMainView.data[
        INFO_GROUP_SECONDARY_FILTERS.NAME.key
      ][0];
      if (nameValue) query.name = nameValue;
    }
    if (INFO_GROUP_SECONDARY_FILTERS.STATUS.key in this.dataToMainView.data) {
      const stateValues = this.dataToMainView.data[
        INFO_GROUP_SECONDARY_FILTERS.STATUS.key
      ] as Array<string>;
      if (stateValues && stateValues.length == 1) query.state = stateValues[0];
    }
    return query;
  }

  cancelInfoGroup() {
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
  }

  async clickData(label: string) {
    this.filterQuery = {
      state: label,
      chart: "true"
    };
    await this.searchData();
  }

  async clickOut() {
    this.filterQuery = { chart: "true" };
    await this.searchData();
  }

  async loadInfoGroup(action: string, itemId: string) {
    this.selectedInfoGroupId = itemId;
    await this.getInfoGroupById(itemId);
    this.isEditing = true;
    this.updateEditing = 1 - this.updateEditing;
    this.showInfoGroup(action, itemId);
    Utils.scrollToElement(SAVE_INFO_GROUP_ID, this);
  }

  cleanInfoGroup() {
    this.TITLE_PAGE = INFO_GROUP_CONSTANTS.PAGE_TITLE;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.showInfoGroupComponent = false;
    this.selectedInfoGroupId = "";
  }

  onButtonAdd() {
    this.showInfoGroup(this.TOGGLE);
  }
}
